module.exports = __webpack_public_path__ + "img/vk.89c6b0b.png";